import {Fragment} from 'react';

import {TransferLogs} from '../component/TransferLogs';

export default function ToKhaiDangKy() {

  return (
    <Fragment>
      <TransferLogs type="Declare" showInvoiceInfo={false}/>
    </Fragment>
  );
}
